import { StripeElementsOptions, loadStripe } from '@stripe/stripe-js';

// eslint-disable-next-line @typescript-eslint/dot-notation
export const StripeAPIKey = (isCreate: boolean) => (isCreate ? process.env['NEXT_PUBLIC_STRIPE_CREATE_PUBLISH_KEY'] ?? '' : process.env['NEXT_PUBLIC_STRIPE_SUPREME_PUBLISH_KEY'] ?? '');

export const StripeCreatePromise = loadStripe(StripeAPIKey(true));
export const StripeSupremePromise = loadStripe(StripeAPIKey(false));

export const StripeOptionsCreate: StripeElementsOptions = {
    fonts: [
        {
            family: 'Gerstner Programm FSL',
            src: 'url(https://app.bpmsupreme.com/_next/static/media/GerstnerProgrammFSLWeb-Bold.fd81b57e.woff2)',
            weight: '700',
        },
        {
            family: 'Gerstner Programm FSL',
            src: 'url(https://app.bpmsupreme.com/_next/static/media/GerstnerProgrammFSLWeb-Medium.1cf69ddc.woff2)',
            weight: '500',
        },
        {
            family: 'Gerstner Programm FSL',
            src: 'url(https://app.bpmsupreme.com/_next/static/media/GerstnerProgrammFSLWeb-Regular.1cf69ddc.woff2)',
            weight: '400',
        },
        {
            family: 'Gerstner Programm FSL',
            src: 'url(https://app.bpmsupreme.com/_next/static/media/GerstnerProgrammFSLWeb-Light.597ff2a0.woff2)',
            weight: '300',
        },
    ],
    appearance: {
        theme: 'flat',
        variables: {
            colorPrimary: '#1af085',
            colorBackground: '#212121',
            colorText: '#B3B3B3',
            borderRadius: '4px',
        }
    },
};

export const StripeOptionsSupreme: StripeElementsOptions = {
    fonts: [
        {
            family: 'Gerstner Programm FSL',
            src: 'url(https://app.bpmsupreme.com/_next/static/media/GerstnerProgrammFSLWeb-Bold.fd81b57e.woff2)',
            weight: '700',
        },
        {
            family: 'Gerstner Programm FSL',
            src: 'url(https://app.bpmsupreme.com/_next/static/media/GerstnerProgrammFSLWeb-Medium.1cf69ddc.woff2)',
            weight: '500',
        },
        {
            family: 'Gerstner Programm FSL',
            src: 'url(https://app.bpmsupreme.com/_next/static/media/GerstnerProgrammFSLWeb-Regular.1cf69ddc.woff2)',
            weight: '400',
        },
        {
            family: 'Gerstner Programm FSL',
            src: 'url(https://app.bpmsupreme.com/_next/static/media/GerstnerProgrammFSLWeb-Light.597ff2a0.woff2)',
            weight: '300',
        },
    ],
    appearance: {
        theme: 'flat',
        variables: {
            colorPrimary: '#F73E00',
            colorBackground: '#212121',
            colorText: '#B3B3B3',
            borderRadius: '4px',
        }
    },
};
